<template>
  <p>
    Desculpe, houve um problema na emissão da forma de pagamento.
  </p>
  <p>
    Se o problema persistir entre em contato com nosso atendimento.
  </p>
</template>
